export default __webpack_public_path__ + "static/media/linkedin1.619cf0e4.png";